var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignHorizontalCenter = function SvgAlignHorizontalCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.667 11.333a.667.667 0 0 0 .666-.666V9.333a.667.667 0 0 0-.666-.666H3.333a.667.667 0 0 0-.666.666v1.334c0 .368.298.666.666.666zM10.667 7.333a.667.667 0 0 0 .666-.666V5.333a.667.667 0 0 0-.666-.666H5.333a.667.667 0 0 0-.666.666v1.334c0 .368.298.666.666.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.333 13.333V2.667a.667.667 0 0 1 1.334 0v10.666a.667.667 0 1 1-1.334 0"
  })));
};
export default SvgAlignHorizontalCenter;